export function groundOffset(point) {
  return point.ground || 0;
}
